<div class="st-drawer-wrapper">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span class="text-header-18 text-semibold">Añadir contenedores</span>

    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <!--  Content  -->
  <div class="st-drawer-content">

    @if (!loading) {
      <!--  Stepper  -->
<!--      <div *ngIf="step !== 3 && nzData.isCreateContainer" class="stepper">-->
<!--        <div class="stepper-item" [ngClass]="{'active': step === 1}" (click)="step = 1">-->
<!--          <span>1. Contenedores</span>-->
<!--        </div>-->

<!--        <app-st-icon name="keyboard_arrow_right"></app-st-icon>-->

<!--        <div class="stepper-item" [ngClass]="{'active': step === 2}"-->
<!--             (click)="stepOneValid() ? changeToStepTwo() : null">-->
<!--          <span>2. Crear Órdenes</span>-->
<!--        </div>-->
<!--      </div>-->

      <!--  Contenido  -->
      <div class="content-wrapper"
           [class.custom-height]="!(ps.selectedProject && ps.selectedProject.services && ps.selectedProject.services.length > 0)">

        @if (step === 1) {
          <!--  Contenedores  -->
          <div>
            <p class="text-dark">Selecciona el tipo de contenedor de los contenedores que vas a cargar:</p>

            <div class="flex flex-column gap-100">
              <span class="text-label-10">Tipo de contenedor</span>
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large" nzShowSearch
                         [compareWith]="compareById"
                         [(ngModel)]="selectedContainerType">
                <nz-option *ngFor="let type of nzData.containerTypes"
                           [nzLabel]="type.description"
                           [nzValue]="type"
                ></nz-option>
              </nz-select>
            </div>
          </div>

          <div>
            <p class="text-dark">Introduce las referencias de contenedor que quieras cargar al proyecto. Deben estar
              separadas por un salto de línea. </p>

            <span [style.color]="visitedTip ? '#00254D' : '#0072F5'" (click)="visitedTip = true" class="cursor-pointer"
                  nz-dropdown [nzTrigger]="'click'" [nzDropdownMenu]="tip">
            <app-st-icon name="lightbulb_2" [bold]="true" [color]="visitedTip ? '#00254D' : '#0072F5'"></app-st-icon>
            <span style="text-decoration: underline">Consejos sobre el formateo de matrículas...</span>
          </span>

            <nz-dropdown-menu #tip="nzDropdownMenu">
              <nz-card>
                <div class="flex flex-column gap-150">
                  <p class="text-dark text-semibold">Formateo de matrículas</p>
                  <p class="text-label-12 text-dark">
                    Las referencias deben estar separadas por salto de línea, ya que es el formato que Excel usa al
                    copiarlas desde una columna.
                  </p>
                  <p class="text-label-12 text-dark">
                    Si tus datos están en otro formato, puedes usar ChatGPT o similar para convertirlos con este prompt:
                  </p>
                  <p class="text-label-12 text-dark text-semibold">
                    “Convierte esta lista de referencias para que cada una aparezca en una línea distinta, sin comas,
                    puntos, guiones ni ningún otro signo. Solo quiero una referencia por línea.”
                  </p>
                </div>
              </nz-card>
            </nz-dropdown-menu>


            <div class="flex flex-column gap-100">
              <span class="text-label-10">Referencias contenedores</span>
              <textarea [(ngModel)]="containersReferences"
                        (ngModelChange)="generateDataFromString()"
                        rows="4" nz-input class="info-text" nzAutosize
                        placeholder="Introduce Referencias contenedores..."></textarea>
            </div>

            <!-- Warning para referencias duplicadas -->
            <app-warning-area
              *ngIf="duplicateReferences.length > 0"
              [show]="true"
              [messageTmpl]="warningMessageTmpl">
            </app-warning-area>

            <ng-template #warningMessageTmpl>
              Las siguientes referencias no serán creadas porque ya existen en el proyecto:
              <p><strong>{{ duplicateReferences.join(', ') }}</strong></p>
            </ng-template>
          </div>
        } @else {
          @if (ps.selectedProject && ps.selectedProject.services && ps.selectedProject.services.length > 0) {
            <!--  Crear Órdenes  -->
            <p class="text-dark">Selecciona un servicio para crear las órdenes con las matrículas indicadas.</p>

            <div class="flex flex-column gap-100">
              <span class="text-label-10">Servicio</span>
              <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large" nzShowSearch
                         [compareWith]="compareById"
                         [(ngModel)]="selectedService">
                <nz-option *ngFor="let service of ps.selectedProject!.services"
                           [nzLabel]="service.name"
                           [nzValue]="service"
                ></nz-option>
              </nz-select>
            </div>

            <nz-table #table [nzData]="tabeData" [nzScroll]="{x: '729px'}" class="st-bordered"
                      [nzShowPagination]="false">
              <tr>
                @for (column of columns; track column) {
                  <th *ngIf="!column.checkbox" [nzAlign]="column.align || null" style="white-space: nowrap"
                      [style.min-width]="column.name === 'Documentación' ? 'max-content' : undefined"
                      [style.width]="column.width ? (column.width + 'px') : 'auto'">{{ column.name }}
                  </th>
                  <th *ngIf="column.checkbox" nzAlign="center"
                      [style.width]="column.width ? (column.width + 'px') : 'auto'">
                    <label nz-checkbox
                           [nzIndeterminate]="isIndeterminate"
                           [nzChecked]="isAllSelected"
                           (nzCheckedChange)="toggleSelectAllData()">
                    </label>
                  </th>
                }
              </tr>
              <tbody>
                @for (item of table.data; track item.containerReference) {
                  <tr>
                    <td nzAlign="center">
                      <label nz-checkbox class="top-0"
                             [nzChecked]="selectedDataReferences.has(item.containerReference)"
                             [nzDisabled]="!item.isActive"
                             (nzCheckedChange)="toggleSelectData(item.containerReference)">
                      </label>
                    </td>
                    <td>{{ item.serviceOrderNumber }}</td>
                    <td>{{ item.containerReference }}</td>
                  </tr>
                }
              </tbody>
            </nz-table>
          } @else {
            <app-empty-state style="flex-grow: 1" class="flex-center"
                             [class.custom-padding]="!(screenService.isMobile$ | async)"
                             [icon]="'error'" [hideBtn]="true" [object]="'servicios'"
                             [height]="'auto'"
                             [customText]="'Para poder crear órdenes con los contenedores debe haber al menos un servicio en el proyecto'"
            ></app-empty-state>
          }
        }

      </div>

    } @else {
      <nz-skeleton style="padding: 32px" [nzActive]="true" [nzParagraph]="{ rows: 5 }"></nz-skeleton>
    }
  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer" [class.show-border]="step !== 1">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar
    </button>

    <button hidden (click)="changeToStepTwo()" *ngIf="step === 1" [disabled]="!stepOneValid()"
            class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="large">
      <span>Siguiente</span>
      <app-st-icon class="sufix" [name]="'arrow_forward'" [bold]="true"></app-st-icon>
    </button>

    <div *ngIf="step === 1" class="flex gap-200">
      <button *ngIf="nzData.isCreateContainer" (click)="createContainer(true)"
              class="text-btn-14" nz-button
              [nzType]="'primary'"
              nzShape="round" nzSize="large">
        <app-st-icon *ngIf="creatingContainer !== 2 && nzData.isCreateContainer" class="prefix" [name]="'add'"
                     [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="creatingContainer === 2" class="prefix" [name]="'progress_activity'"
                     [bold]="true"></app-st-icon>
        <span>Guardar contenedores</span>
      </button>

      <button hidden *ngIf="ps.selectedProject
                     && ps.selectedProject.services
                     && ps.selectedProject.services.length > 0
                     && !!authService.loggedUser$.value?.generateOrders"
              (click)="createContainer(false)"
              [disabled]="selectedDataReferences.size === 0 || !selectedService"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="creatingContainer !== 1 && nzData.isCreateContainer" class="prefix" [name]="'add'"
                     [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="creatingContainer === 1" class="prefix" [name]="'progress_activity'"
                     [bold]="true"></app-st-icon>
        <span>{{ nzData.isCreateContainer ? 'Guardar y crear OS' : 'Crear OS' }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
